/**
 * MoodMapPage - Main page for the MoodMap daily reflection feature
 */

import { useEffect } from 'react';
import { useMoodMapStore } from '../stores/moodmapStore';
import MoodMapHeader from '../components/moodmap/MoodMapHeader';
import MoodMapSummary from '../components/moodmap/MoodMapSummary';
import MoodMapCalendar from '../components/moodmap/MoodMapCalendar';
import YearlyHeatmap from '../components/moodmap/YearlyHeatmap';
import DayEntryModal from '../components/moodmap/DayEntryModal';

const MoodMapPage = () => {
  const {
    isLoading,
    initialize,
    viewMode,
    isDayModalOpen,
    closeDayModal,
  } = useMoodMapStore();

  // Initialize on mount
  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Header with navigation and streak */}
      <MoodMapHeader />

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Summary cards */}
        <MoodMapSummary />

        {/* Calendar view */}
        <div className="mt-6">
          {isLoading ? (
            <LoadingState />
          ) : viewMode === 'yearly' ? (
            <YearlyHeatmap />
          ) : (
            <MoodMapCalendar />
          )}
        </div>
      </main>

      {/* Modals */}
      <DayEntryModal isOpen={isDayModalOpen} onClose={closeDayModal} />
    </div>
  );
};

// Loading state component
const LoadingState = () => (
  <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-8 flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-2 border-purple-500 border-t-transparent rounded-full animate-spin" />
      <p className="text-gray-400">Yükleniyor...</p>
    </div>
  </div>
);

export default MoodMapPage;
